import QuestionModel from "../../maths/QuestionModel";
import QuestionViewVerbalConversion from "./QuestionViewVerbalConversion";

export default class QuestionViewVerbalTime extends QuestionViewVerbalConversion{
	constructor(question) {
		super(question);
	}

	getHeaderText() {
		const data = P3.assets.json("templates");
		this._answer = this._question.answer;

		let template = this._getTemplate(data);
		let text = template ? template.text : "";
		let words = data.words;

		const genericLocations = this.generateWords(text, words.generic_locations, /\[GENERIC_LOCATION([0-9])?]/g);
		for (const i in genericLocations) {
			if (genericLocations.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), genericLocations[i]);
			}
		}
		const verb = this.generateWords(text, words.verb, /\[VERB([0-9])?]/g);
		for (const i in verb) {
			if (verb.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), verb[i]);
			}
		}
		text = this._replaceValues(text);
		text = this._replaceEnemies(data.words.enemies, text);

		return text;
	}

	_replaceValues(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if (match){
			for (let i = 0; i < match.length; i++) {
				text = text.replace(match[i], this._question.values[i].toTime());
			}
		}
		return text;
	}

	filterTemplate(x) {
		return x.view === this.question.view;
	}

	isCorrect() {
		return this._inputValue ? this._inputValue.value[0] === this._question.answer.value[0] && this._inputValue.value[1] === this._question.answer.value[1] : false;
	}
}